import React from 'react';
import { useRouter } from 'next/router';
import { Menu } from '@cvent/carina/components/Menu';
import { TextLink } from '@cvent/carina/components/TextLink';
import { ChevronDownIcon } from '@cvent/carina/components/Icon';
import { useTranslate } from 'nucleus-text';

import { useFormStyle } from '@hooks/style/useFormStyle';
import { useProducts, useSourceProduct } from '@components/providers/ProductProvider';
import { useAlert } from '@components/providers/ErrorProvider';

type ProductMenuProps = {
  testID: string;
};

export const ProductMenu = ({ testID }: ProductMenuProps): JSX.Element => {
  const router = useRouter();
  const { translate } = useTranslate();
  const { productSelectMenu } = useFormStyle();
  const { sourceProduct, updateSourceProduct } = useSourceProduct();
  const { products } = useProducts();
  const { updateAlert } = useAlert();

  const productOptions = products.map(product => {
    return { label: translate('form_title_product_name', { productName: product.label }), value: product };
  });

  const onProductSelect = async ({ value }) => {
    await router.push(
      {
        pathname: '/multiproductauth',
        query: { ...router.query, sourceProductId: value.id }
      },
      undefined,
      {
        shallow: true
      }
    );

    updateSourceProduct(value);
    updateAlert({});
  };

  return (
    <Menu
      testID={`${testID}_productMenu`}
      options={productOptions}
      selected={sourceProduct.id}
      onSelect={onProductSelect}
      trigger={(handlePress): JSX.Element => (
        <TextLink testID={`${testID}_productButton`} onClick={handlePress} target="_blank" css={productSelectMenu}>
          {translate('form_title_product_name', { productName: sourceProduct.label })}
          <ChevronDownIcon />
        </TextLink>
      )}
      portal
    />
  );
};
